import MigrateActive from "./components/Main/MigrateActive/MigrateActive";
import MigrateBaned from "./components/Main/MigrateBaned/MigrateBaned";
import MigrateByID from "./components/Main/MigrateById";
import MigrateMoreInfo from "./components/Main/MigrateMoreInfo/MigrateMoreInfo";
import MigrateSummary from "./components/Main/MigrateSummary";
import MigrateEmailContact from "./components/Main/MigrateEmailContact/MigrateEmailContact";

export const configFile = [
    {
        tab: 'tab-1',
        tag: 'span',
        title: 'Migrar Todo el inventario',
        Contents: MigrateSummary,
    },
    {
        tab: 'tab-2',
        tag: 'span',
        title: 'Migrar por ID',
        Contents: MigrateByID,
    },
    {
        tab: 'tab-3',
        tag: 'span',
        title: 'Migrar inventario activo',
        Contents: MigrateActive,
    },
    {
        tab: 'tab-4',
        tag: 'span',
        title: 'Solicitudes de información',
        Contents: MigrateMoreInfo,
    },
    {
        tab: 'tab-5',
        tag: 'span',
        title: 'Migración por email de contactación',
        Contents: MigrateEmailContact,
    },
    {
        tab: 'tab-6',
        tag: 'span',
        title: 'Baneado',
        Contents: MigrateBaned,
    }
];
